import { render, staticRenderFns } from "./products.vue?vue&type=template&id=49b89893&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBreadCrumb: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppBreadCrumb.vue').default,AppBackToTopButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppBackToTopButton.vue').default})
